/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating';
import {
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSONTyped,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating';

/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions {
    /**
     * Скриншоты игры для страницы магазина
     * @type {Array<string>}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    Screenshots?: Array<string> | null;
    /**
     * Количество установок игры
     * @type {number}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    InstallCount?: number | null;
    /**
     * 
     * @type {FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    Rating?: FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating | null;
    /**
     * Жанр игры
     * @type {Array<string>}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    Genre?: Array<string> | null;
    /**
     * Дата последнего обновления
     * @type {Date}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    LastUpdate?: Date | null;
    /**
     * mp4 видео для страницы магазина  290x464
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions
     */
    VideoUrl?: string | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions {
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Screenshots': json['Screenshots'] == null ? undefined : json['Screenshots'],
        'InstallCount': json['InstallCount'] == null ? undefined : json['InstallCount'],
        'Rating': json['Rating'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON(json['Rating']),
        'Genre': json['Genre'] == null ? undefined : json['Genre'],
        'LastUpdate': json['LastUpdate'] == null ? undefined : (new Date(json['LastUpdate'])),
        'VideoUrl': json['VideoUrl'] == null ? undefined : json['VideoUrl'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Screenshots': value['Screenshots'],
        'InstallCount': value['InstallCount'],
        'Rating': FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON(value['Rating']),
        'Genre': value['Genre'],
        'LastUpdate': value['LastUpdate'] == null ? undefined : ((value['LastUpdate'] as any).toISOString()),
        'VideoUrl': value['VideoUrl'],
    };
}

